import React from 'react';
import { Card, DotIcon, Input } from '@avila-tek/ui/src';
import { BenefitRequest, User } from '../../../models';
import { FormHeader } from '../../shared/Forms';
import { translateBenefitStatusRequest } from '../RequestTable/RequestTable';

interface RequestFormProps {
  formState: Partial<BenefitRequest>;
  setFormState: React.Dispatch<React.SetStateAction<Partial<BenefitRequest>>>;
  request: BenefitRequest;
}

function RequestFormContent({
  formState,
  setFormState,
  request,
}: RequestFormProps) {
  return (
    <Card>
      <FormHeader
        href="/app/requests"
        title="Gestionar solicitud"
        backBtnText="Solicitudes"
      />
      <Card.Body>
        <div className="w-full flex md:flex-row flex-col gap-5 ">
          <div className="w-full">
            <Input
              value={`${request?.user?.firstName ?? ''} ${
                request?.user?.lastName ?? ''
              }`}
              label="Nombre"
              type="text"
              name="title"
              className="bg-slate-100"
              disabled
            />
          </div>
          <div className="w-full">
            <Input
              value={(formState.createdAt as string) ?? ''}
              label="fecha de solicitud"
              name="createdAt"
              type="text"
              className="bg-slate-100"
              disabled
            />
          </div>
        </div>
        <div className="w-full flex md:flex-row flex-col gap-5">
          <div className="w-full md:w-1/2 pr-2">
            <Input
              value={request.amountRequested}
              label="Monto solicitado en beneficios ($)"
              type="number"
              className="bg-slate-100"
              disabled
            />
          </div>
          <div className="w-full md:w-1/2 pr-2">
            <Input
              value={formState.amountApproved}
              label="Monto aprobado en beneficios ($)"
              type="number"
              placeholder="Ingrese el monto que desea aprobar de la solicitud"
              onChange={(e) => {
                setFormState({
                  ...formState,
                  amountApproved: Number(e.target.value),
                });
              }}
              disabled={request.status !== 'pending'}
              required
            />
          </div>
        </div>
        <div className="w-full flex md:flex-row flex-col gap-5">
          <div className="w-full md:w-1/2 pr-2">
            <p className="flex gap-2 items-center">
              <span className="font-semibold text-purple-300">Estatus: </span>
              <DotIcon
                className={` ${
                  request.status === 'approved' && request.active
                    ? 'text-success-300'
                    : ' text-danger-200'
                } w-5 h-5`}
              />

              {translateBenefitStatusRequest[request.status]}
            </p>
          </div>
        </div>
      </Card.Body>
    </Card>
  );
}

export default RequestFormContent;
